export const isValidDate = (d: Date): boolean => {
  return d instanceof Date && !isNaN(d as any);
};
